import { register, Tag, Transaction, defineProperty, defineRelation, Direction } from 'olympe';
import FactorTarget from './FactorTarget';

/**
 * @extends {FactorTarget}
 */
export default class Influence extends FactorTarget {

    /**
     * @return {string}
     */
    getName() {
        return this.get(Influence.nameProp);
    }
}

// Hardcoded tags
register('01894f0ef1a9e1c98100', Influence);
Influence.nameProp = defineProperty('01894f0f92f008fd9ccf');
Influence.inverse_aspectinfluencesRel = defineRelation('01894f1028cd94191541', Direction.ORIGIN);
